import type { FC } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessage, useIntl } from 'react-intl';
import { GetIcon } from '../../../../components/icons';
import { DEFAULT_CURRENCY } from '../../../../constants';
import { Text, Tooltip, TooltipPlacement } from '../../../../ui-components';

const handlingFeeTooltip = defineMessage({
    id: 'buy.box.handling.fee.title',
    defaultMessage: 'Handling and Shipping Fee applied in cart',
});

interface HandlingFeeProps {
    handlingFee: number;
    currency?: string;
}

export const HandlingFee: FC<HandlingFeeProps> = ({ handlingFee, currency = DEFAULT_CURRENCY }) => {
    const intl = useIntl();

    return (
        <div className="flex items-center gap-1 pt-1" data-testid="buy-box-handling-fee">
            <Text>
                <FormattedMessage
                    id="buy.box.handling.fee"
                    defaultMessage="+{handlingFee} Handling Fee"
                    values={{
                        handlingFee: intl.formatNumber(handlingFee, {
                            currency,
                            style: 'currency',
                            currencyDisplay: 'narrowSymbol',
                        }),
                    }}
                />
            </Text>
            <Tooltip
                label={intl.formatMessage(handlingFeeTooltip)}
                placement={TooltipPlacement.top}
            >
                <div className="flex" data-testid="buy-box-handling-fee-tooltip">
                    <GetIcon name="info" size="md" />
                </div>
            </Tooltip>
        </div>
    );
};

HandlingFee.propTypes = {
    handlingFee: PropTypes.number.isRequired,
    currency: PropTypes.string,
};

HandlingFee.defaultProps = {
    currency: DEFAULT_CURRENCY,
};
